import {
  Button,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import FieldsProdep, { prodepInitialState } from "../../fieldsProdep";
import { useEffect, useState } from "react";
import Copyright from "../../common/CopyRight";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import { schemaProdep } from "../../validations/prodep";
import InputSelect from "../../components/FormElements/InputSelect";
import InputTextOutlined from "../../components/FormElements/InputTextOutlined";
import {
  PRODEP_GRADE,
  PRODEP_PROCEDURE,
  PRODEP_PROGRAMA,
  PRODEP_REGION,
} from "../../constants/prodep";
import TableStudentProdep from "../../common/TableStudentProdep";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { PdfConstancia } from "./constanciasER/pdfConstancia";

const ConstanciasER = () => {
  const {
    fields,
    handleSave,
    errors,
    handleSubmit,
    validSubmit,
    resetForm,
    setValues,
    handleSaveRepeaterProp,
  } = FieldsProdep(prodepInitialState);

  const [isVisibleForm, setIsVisibleForm] = useState(true);
  const [isVisibleDownload, setIsVisibleDownload] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    (async () => {
      if (validSubmit) {
        setIsVisibleForm(false);
      }
    })();
  }, [validSubmit]);

  const handleChange = (e, schema) => {
    const obj = {
      target: {
        name: `${e.target.name}`,
        value: e.target.value,
      },
    };

    handleSaveRepeaterProp(obj, schema);
  };

  const handleRows = (students) => setValues((prev) => ({ ...prev, students }));

  const handleReset = () => setModalOpen(true);

  const handleCloseModal = () => {
    Promise.all([
      resetForm(),
      setIsVisibleDownload(false),
      setModalOpen(false),
    ]);
  };
  return (
    <>
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"¿Estas seguro que deseas Salir?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Estas seguro que deseas salir, la contancia generada no podra volver
            a ser consultada!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ marginRight: "auto" }}
            onClick={() => setModalOpen(false)}
          >
            Regresar
          </Button>
          <Button onClick={handleCloseModal} autoFocus>
            Salir
          </Button>
        </DialogActions>
      </Dialog>
      <Container component="main" maxWidth="xl" sx={{ mb: 4 }}>
        <Paper
          variant="outlined"
          sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
        >
          <Collapse
            in={isVisibleDownload}
            orientation="vertical"
            onExited={() => setIsVisibleForm(true)}
          >
            <Stack
              justifyContent="space-between"
              direction="row"
              spacing={2}
              sx={{ my: 4 }}
            >
              <Button
                variant="contained"
                type="button"
                startIcon={<FileDownloadIcon />}
              >
                <PDFDownloadLink
                  document={<PdfConstancia fields={fields} />}
                  fileName="constancia_er.pdf"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  {({ blob, url, loading, error }) =>
                    loading ? "Loading document..." : "Descargar Constancia"
                  }
                </PDFDownloadLink>
              </Button>

              <Button
                variant="contained"
                type="button"
                color={"error"}
                endIcon={<DisabledByDefaultIcon />}
                onClick={handleReset}
              >
                Salir
              </Button>
            </Stack>

            <PDFViewer style={{ width: "100%", minHeight: 1000 }}>
              <PdfConstancia fields={fields} />
            </PDFViewer>
          </Collapse>

          <Collapse
            in={isVisibleForm}
            orientation="vertical"
            onExited={() => setIsVisibleDownload(true)}
          >
            <Typography component="h1" variant="h4" align="center">
              Constancias E.R.
            </Typography>
            <Typography
              component="h1"
              variant="h6"
              align="center"
              sx={{ paddingY: 2 }}
            >
              Académico
            </Typography>
            <Grid
              container
              spacing={2}
              component="form"
              onSubmit={(e) => handleSubmit(e, schemaProdep)}
            >
              <Grid item xs={12} md={2}>
                <InputSelect
                  id={"grade"}
                  label="Grado"
                  opts={PRODEP_GRADE}
                  error={errors?.grade?.txt}
                  initialValue={fields?.grade}
                  onChangeInput={handleSave}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputTextOutlined
                  id={"professor"}
                  size={"normal"}
                  label="Nombre del Docente"
                  error={errors?.professor?.txt}
                  initialValue={fields?.professor}
                  onChangeInput={(e) => handleSave(e)}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputTextOutlined
                  id={"id_professor"}
                  size={"normal"}
                  label="No. de Personal"
                  error={errors?.id_professor?.txt}
                  initialValue={fields?.id_professor}
                  onChangeInput={handleSave}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputSelect
                  id={"program"}
                  label="Programa Educativo"
                  opts={PRODEP_PROGRAMA}
                  placeholder=""
                  error={errors?.program?.txt}
                  initialValue={fields?.program}
                  onChangeInput={handleSave}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputSelect
                  id={"region"}
                  label="Región"
                  opts={PRODEP_REGION}
                  placeholder=""
                  error={errors?.region?.txt}
                  initialValue={fields?.region}
                  onChangeInput={handleSave}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputSelect
                  id={"procedure"}
                  label="Tramite"
                  opts={PRODEP_PROCEDURE}
                  placeholder=""
                  error={errors?.procedure?.txt}
                  initialValue={fields?.procedure}
                  onChangeInput={handleSave}
                />
              </Grid>
              <Grid item xs={12}>
                <Divider
                  sx={{ borderColor: "gray", marginTop: 3, marginBottom: 1 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  component="h1"
                  variant="h6"
                  align="center"
                  sx={{ paddingBottom: 2 }}
                >
                  Lista de estudiantes
                </Typography>
                <TableStudentProdep
                  fields={fields.students}
                  errors={errors.students}
                  onHandleChange={handleChange}
                  onHandleRows={handleRows}
                ></TableStudentProdep>
              </Grid>
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <Button
                  variant="contained"
                  type="submit"
                  startIcon={<CheckCircleIcon />}
                  sx={{ marginY: 4 }}
                >
                  Generar Constancia
                </Button>
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
        <Copyright />
      </Container>
    </>
  );
};

export default ConstanciasER;
